<script setup lang="ts">
import IconStatusWhite from '@icons/ph_status_white.svg';
import Icon from '@components/Icon.vue';
import type { WithProfilePictureUser } from '@models/interfaces/withProfilePictureUser';
import { computed } from 'vue';
import MediaImage from '@components/MediaImage.vue';
import { type Color, getColorValue } from '@global-types/colors';

const { user, size = 24, isOnline = false } = defineProps<{
  user: WithProfilePictureUser,
  size?: number,
  isOnline?: boolean
}>();

const initials = computed<string>(() => {
  const { firstname } = user;
  return firstname[0].toUpperCase();
  // @todo Standby for now, specs to come
  // const lastname = user.lastname;
  // return firstname[0].toUpperCase() + lastname[0].toUpperCase();
});

const colors: Color[] = [ 'green', 'blue', 'red', 'yellow', 'orange', 'black', 'purple' ];

const backgroundColor = computed<string>(() => {
  const letter = initials.value[0];
  if (!letter) {
    return 'black';
  }
  const normalized = letter.toUpperCase().charCodeAt(0);
  const index = normalized % colors.length;
  return getColorValue(colors[index]);
});
</script>

<template>
  <div class="user-picture">
    <div
      v-if="user.profile_picture"
      class="user-picture__image picture-image"
      :style="{ width: `${size}px`, height: `${size}px` }"
    >
      <MediaImage
        class="picture-image__media"
        :uuid="user.profile_picture.uuid as string"
        :alt="user.full_name"
        :ratio="[ 1, 1 ]"
        :width="size"
        :height="size"
        :crop="[ size, size ]"
        :draggable="false"
      />
    </div>
    <div
      v-else
      class="user-picture__initials"
      :style="{ width: `${size}px`, height: `${size}px`, backgroundColor }"
    >
      {{ initials }}
    </div>
    <Icon
      v-if="isOnline"
      :svg="IconStatusWhite"
      class="user-picture__online-status"
    />
  </div>
</template>

<style lang="scss">
@use '@styles/components/user-picture';
</style>
